import React from 'react';
import { STIcon } from 'components/Brand/Icons/STIcon';
import Text from 'components/Text';
import { Container } from './styles';

const PlayLabel = ({ label, labelSize, isPlaying, setIsPlaying, theme, onClick = () => {} }) => {
  const svgHeight =
    labelSize === 'Large'
      ? '25px'
      : labelSize === 'Medium'
      ? '20px'
      : labelSize === 'Normal'
      ? '16px'
      : labelSize === 'Small'
      ? '13px'
      : labelSize;

  const getLabel = () => {
    if (typeof label === 'string') {
      return (
        <Text type="p" color="white" marginMobile="0">
          {label}
        </Text>
      );
    } else {
      return label;
    }
  };

  return (
    <Container
      className="play-label"
      onClick={e => {
        setIsPlaying(!isPlaying);
        onClick && onClick(e);
      }}
    >
      <STIcon
        style={{ height: svgHeight }}
        type="icon-play"
        fill={
          theme.includes('var(') ? theme : theme === 'light' ? 'var(--white)' : 'var(--black-color)'
        }
      />
      {getLabel()}
    </Container>
  );
};

export default PlayLabel;

PlayLabel.defaultProps = {
  theme: 'light',
  label: 'Play Video',
};
